import React from 'react';

import { FormattedDate } from 'react-intl';
import { InputProps } from './Input';

import { Option } from 'react-select/src/filters';
import { FieldInputProps, FieldProps } from 'formik';
import { SelectItemView } from 'view/component/Select/SelectItem';


import './input.scss'
import { SelectProps } from 'view/component/Select/Select';


export type ReadViewFunction = (props: InputProps, formikProps: FieldProps) => React.ReactNode;

export class InputVisualizacaoRender {

  static get(type: string): ReadViewFunction {
    // if type === "number"
    //   return 
    if (type === "date")
      return (props: InputProps, formikProps: FieldProps) => InputVisualizacaoRender.date(props, formikProps)
    // if type === "time"

    return (props: InputProps, formikProps: FieldProps) => InputVisualizacaoRender.text(props, formikProps)
  }

  static text(props: InputProps, formikProps: FieldProps): React.ReactNode {
    return formikProps.meta.value;
  }

  static date(props: InputProps, formikProps: FieldProps): React.ReactNode {
    return <FormattedDate value={formikProps.meta.value} />
  }

  static select(props: SelectProps, formikProps: FieldProps): React.ReactNode|undefined {
    const option = SelectVisualizacaoRender.getValue(props, formikProps.field)
    if (option === undefined || option === '' || (Array.isArray(option) && option.length === 0)) {
      return undefined;
    }

    const options = Array.isArray(option) ? option : [option]
    return options.map((it, index) => <SelectItemView key={index} option={it} /> );
  }
}


export class SelectVisualizacaoRender {

  public static getValue(props: SelectProps, field: FieldInputProps<any>) {
    const options = props.options as any;

    const value = field.value?.value
      ? field.value?.value 
      : field.value

    if (options && value) {
      return props.isMulti
        ? this.findOptions(value, options, field)
        : SelectVisualizacaoRender.findOption({options: options}, field)
    }

    return props.isMulti ? [] : ("" as any);
  }

  private static findOptions(value: any[] | any, options: any, field: any) {
    const newValue: any[] = Array.isArray(value) ? value : [value]

    return newValue.map(e => SelectVisualizacaoRender.findOption({options: options}, {value: e}))
  }

  /**
   * Busca recursiva da opção selecionada pelo usuário
   */
  private static findOption(option: any, field: any) : Option | undefined {
    if (option.value !== undefined) {
      return String(option.value) === String(field.value)
        ? option
        : undefined
    }

    for (let opt of option.options) {
      const selectedOption = SelectVisualizacaoRender.findOption(opt, field)

      if (selectedOption) {
        return selectedOption
      }
    }

    return undefined
  }
}
